import { render, staticRenderFns } from "./FollowupTab.vue?vue&type=template&id=43acd277&scoped=true&"
import script from "./FollowupTab.vue?vue&type=script&lang=js&"
export * from "./FollowupTab.vue?vue&type=script&lang=js&"
import style0 from "./FollowupTab.vue?vue&type=style&index=0&id=43acd277&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43acd277",
  null
  
)

export default component.exports